




















import Vue from 'vue'
import { Location as RouteLocation } from 'vue-router'

import NativeBaseImage from '@/common/components/NativeBaseImage.vue'
import { DisplayChildCategory } from '@/common/types/index'
import {
  BRAND_FACET_KEY_NAME,
  FACET_QUERY_PREFIX,
  ROUTE_NAMES
} from '@/search/const'
import { IMAGE_VARIANT_NAMES } from '@/common/constants'

export default Vue.extend({
  components: {
    NativeBaseImage
  },
  props: {
    category: {
      type: Object as () => DisplayChildCategory,
      required: true
    },
    brandName: {
      type: String,
      default: ''
    }
  },
  computed: {
    query(): { [key: string]: string } {
      return this.brandName
        ? { [`${FACET_QUERY_PREFIX}${BRAND_FACET_KEY_NAME}`]: this.brandName }
        : {}
    },
    routeData(): RouteLocation {
      const categoryNames = this.category.url.replace('/categories/', '').split('/')
      return {
          name: ROUTE_NAMES.CHILD_CATEGORY,
          query: this.query,
          params: {
            categoryName: categoryNames[0],
            childCategory: categoryNames[1] || '',
            pageCategoryId: this.category.id.toString()
          }
        }
    },
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    }
  }
})
